<!-- <template>
	<div class="module_container full" style="position: relative;" v-loading="loading">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'" >

		</vxe-grid>

		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />



		<vxe-modal v-model="distributionShow" width="500" height="300" show-footer destroy-on-close transfer
			:lock-scroll="false">
			<template #title>
				<div>分配</div>
			</template>
			<template #default>
				<div style="margin-top: 10px;">
					<distribution ref="distribution" :row='currentrow' />
				</div>
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="distributionShow=false"></vxe-button>
				<vxe-button status="primary" content="确定" @click="distributionSubmit"></vxe-button>
			</template>
		</vxe-modal>


		<vxe-table :data="exportData" style="display: none;" ref="exportTable">
			<vxe-column field="code" title="商品编码" cell-type="string"></vxe-column>
			<vxe-column field="name" title="商品名称" cell-type="string"></vxe-column>
			<vxe-column field="model" title="规格型号" cell-type="string"></vxe-column>
			<vxe-column field="weight" title="重量" cell-type="string"></vxe-column>
			<vxe-column field="recommendlevel" title="推荐等级" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_a" title="供应商A" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_a" title="单价A" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_b" title="供应商B" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_b" title="单价B" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_c" title="供应商C" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_c" title="单价C" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_d" title="供应商D" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_d" title="单价D" cell-type="string"></vxe-column>
		</vxe-table>




	</div>
</template>
<style>

</style>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'
	import distribution from './distribution/index.vue';
	export default {
		extends: listBase,
		name: 'customerIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'customer',
				windowName: '客户',
				exportData: [],
				currentrow:null,
				// priceEditShow: false,
				// noMap: ['a', 'b', 'c', 'd'],
				// priceForm: {
				// 	no: '',
				// 	customerid: 0,
				// 	supplierid: 0,
				// 	code: '',
				// 	name: '',
				// 	model: '',
				// 	suppliername: '',
				// 	price: '',
				// 	row: null
				// },
				distributionShow:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			// save(row) {
			// 	let data = []
			// 	let sort = []
			// 	this.noMap.forEach((item) => {
			// 		if (row['supplierid_' + item]) {
			// 			data.push({
			// 				customerid: row.id,
			// 				supplierid: row['supplierid_' + item],
			// 				price1: row['supplierprice_' + item] ? row['supplierprice_' + item] : null,
			// 			})
			// 		}

			// 		sort.push({
			// 			supplierid: row['supplierid_' + item],
			// 			suppliername: row['suppliername_' + item],
			// 			suppliercode: row['suppliercode_' + item],
			// 			price: row['supplierprice_' + item],
			// 			priceorder: row['supplierprice_' + item] ? row['supplierprice_' + item] : 999999
			// 		})


			// 	})
			// 	sort = sort.sort((a, b) => {
			// 		return a.priceorder - b.priceorder
			// 	})
			// 	this.$api[this.moduleName].updatesupplierprice({
			// 		data: data
			// 	}).then(() => {
			// 		this.$message.success('操作成功')
			// 		this.noMap.forEach((item, index) => {
			// 			if (sort[index]) {
			// 				row['supplierid_' + item] = sort[index].supplierid
			// 				row['suppliercode_' + item] = sort[index].suppliercode
			// 				row['suppliername_' + item] = sort[index].suppliername
			// 				row['supplierprice_' + item] = sort[index].price
			// 			}
			// 		})
			// 	})
			// },
			// add() {
			// 	import('@/components/forms/customer/form.vue').then((res) => {
			// 		this.formModule = {
			// 			component: res.default,
			// 			name: 'customer',
			// 			id: 0,
			// 			controlltype: 1,
			// 			show: true,
			// 		}
			// 	})
			// },
			// edit(row) {
			// 	import('@/components/forms/customer/form.vue').then((res) => {
			// 		this.formModule = {
			// 			component: res.default,
			// 			name: 'customer',
			// 			id: row.id,
			// 			controlltype: 2,
			// 			show: true,
			// 		}
			// 	})
			// },
			distribution(row) {
					this.currentrow = row
					this.distributionShow = true
			},
			distributionSubmit(){
				let data = this.$refs.distribution.submit()
				if (data) {
					this.$api[this.moduleName].distribution(data.id, data).then(() => {
						this.distributionShow = false
						this.customreload()
					})
				}
			},
			autodistribution(){
				alert(1)
			},
			// cellClick({
			// 	row,
			// 	column
			// }) {
			// 	if (column.field.indexOf('supplierprice') !== -1) {
			// 		let no = column.field.split('_')[1]
			// 		let customerid = row.id
			// 		let supplierid = row['supplierid_' + no]
			// 		if (supplierid) {
			// 			this.priceForm.no = no,
			// 				this.priceForm.customerid = customerid
			// 			this.priceForm.supplierid = supplierid
			// 			this.priceForm.code = row.code
			// 			this.priceForm.name = row.name
			// 			this.priceForm.model = row.model
			// 			this.priceForm.suppliername = row['suppliername_' + no]
			// 			this.priceForm.price = row['supplierprice_' + no]
			// 			this.priceForm.row = row
			// 			this.priceEditShow = true
			// 		}

			// 	}

			// },
			// submitPrice() {
			// 	this.priceForm.row['supplierprice_' + this.priceForm.no] = this.priceForm.price

			// },
			// cellStyle({
			// 	row,
			// 	column
			// }) {
			// 	if (column.property.indexOf('supplierprice') !== -1) {
			// 		let no = column.property.split('_')[1]
			// 		if (row['suppliername_' + no] && !row['supplierprice_' + no]) {
			// 			return {

			// 				backgroundColor: 'rgb(240, 249, 235)'
			// 			}
			// 		}
			// 	}



			// },
			importMethod(e) {
				let file = e.file
				let formData = new FormData()
				formData.append('excle', file)
				return new Promise((resolve) => {
					this.$api[this.moduleName].import(formData).then((res) => {
						if (res.errorData.length != 0) {
							let message = ''
							res.errorData.forEach((item) => {
								message = message + item.customercode + '：' + item.erro + '</br>'
							})
							this.$alert(message + '系统已忽略', res.errorData.length + '条数据错误', {
								dangerouslyUseHTMLString: true
							})
						}
						this.customreload()
						resolve()
					}, (e) => {
						this.$message.error(e)
						resolve()
					})
				})

			},
			importtemplate() {
				this.$store.commit('getTemplate', 'customer')
			}
		},
		components: {
			distribution
		}
	}
</script>
